// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"xP-z","categoryName":"yP-z","categoryNameSearchHeader":"zP-z","categoryContent":"AP-z","bottomAligned":"BP-z","image":"CP-z","imageNoBackground":"DP-z"};